import { cn } from "@/lib/utils";
import { memo } from "react";

interface ExamplePromptsProps {
  examplePrompts: string[];
  isDisabled?: boolean;
  onExamplePromptSelected: (examplePrompt: string) => void;
}

const ExamplePrompts = memo(
  ({
    examplePrompts,
    isDisabled,
    onExamplePromptSelected,
  }: ExamplePromptsProps) => {
    return (
      <div className="md:col-span-4 md:col-start-2 md:flex md:justify-center">
        <div className="w-full z-10 px-3 md:pt-3 flex flex-wrap gap-[14px]">
          {examplePrompts.map((examplePrompt) => (
            <button
              key={examplePrompt}
              type="button"
              className={cn(
                "appearance-none bg-shallow hover:bg-accent border border-secondary rounded-full text-primary text-sm font-medium leading-[1.4] py-[0.625rem] px-[1.125rem] hover:cursor-pointer w-full md:w-auto",
                isDisabled && "hover:cursor-not-allowed opacity-50",
              )}
              onClick={() => {
                if (!isDisabled) {
                  onExamplePromptSelected(examplePrompt);
                }
              }}
              disabled={isDisabled}
            >
              {examplePrompt}
            </button>
          ))}
        </div>
      </div>
    );
  },
);

ExamplePrompts.displayName = "ExamplePrompts";

export default ExamplePrompts;
